import { useInvoiceInitContext } from "contexts/invoicePage/InvoiceInitContext";
import { useFormikContext } from "formik";
import { useMemo } from "react";
export default function useInvoicePaymentSummary() {
    var values = useFormikContext().values;
    var sumproductPrice = useInvoiceInitContext().sumproductPrice;
    var _values_factNewInvPayment;
    var factNewInvPayment = (_values_factNewInvPayment = values === null || values === void 0 ? void 0 : values.factNewInvPayment) !== null && _values_factNewInvPayment !== void 0 ? _values_factNewInvPayment : [];
    var discountValue = useMemo(function() {
        return Number(values.discount_value || 0);
    }, [
        values.discount_value
    ]);
    var sumPriceIncDiscount = useMemo(function() {
        if (values.dim_mst_discount_type_id === 1) {
            return sumproductPrice * ((100 - discountValue) / 100);
        }
        return Math.max(sumproductPrice - discountValue, 0);
    }, [
        values.dim_mst_discount_type_id,
        discountValue,
        sumproductPrice
    ]);
    var sumPayment = useMemo(function() {
        return factNewInvPayment.reduce(function(totalSum, payment) {
            var paymentRows = payment.factNewInvPaymentRow || [];
            var adjustments = payment.factNewInvAdjustmentOrFee || [];
            var sumRows = paymentRows.reduce(function(acc, row) {
                return acc + (Number(row.price) || 0);
            }, 0);
            var sumAdjustments = adjustments.reduce(function(acc, adj) {
                return acc + (Number(adj.price) || 0);
            }, 0);
            return totalSum + sumRows + sumAdjustments;
        }, 0);
    }, [
        factNewInvPayment
    ]);
    var countPayment = factNewInvPayment.length;
    var totalToBePaid = useMemo(function() {
        return Number(sumPriceIncDiscount || 0) - sumPayment;
    }, [
        sumPriceIncDiscount,
        sumPayment
    ]);
    return {
        sumPayment: sumPayment,
        totalToBePaid: totalToBePaid,
        countPayment: countPayment,
        sumPriceIncDiscount: sumPriceIncDiscount
    };
}
